export default __webpack_public_path__ + "static/media/saiKiran.5c4631ac.png";